import { render, staticRenderFns } from "./InventoryActions.vue?vue&type=template&id=73bb95ae"
import script from "./InventoryActions.vue?vue&type=script&lang=js"
export * from "./InventoryActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports